import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { ALPHANUMERIC_VALIDATION } from 'utils/yupSchemas/createNameSchema'

const AMOUNT_REGEX = /^(0|[1-9]\d*)(\.\d+)?$/
export const transferSchema = (t: TFunction<'translation', undefined>) => {
  const walletTransferType = yup
    .string()
    .label(t('customers.walletTransferType'))
    .required(
      t('fieldRequired', {
        field: t('customers.walletTransferType'),
        interpolation: { escapeValue: false },
      })
    )

  const customerReference = yup.string().label(t('customers.customer')).required()
  const destinationWallet = yup
    .string()
    .label(t('customers.customerWallet'))
    .required(
      t('fieldRequired', {
        field: t('wallet'),
        interpolation: { escapeValue: false },
      })
    )
  const amount = yup
    .string()
    .label(t('amount'))
    .matches(AMOUNT_REGEX, t('onlyNumericValues'))
    .required(
      t('fieldRequired', {
        field: t('amount'),
        interpolation: { escapeValue: false },
      })
    )

  const paymentReference = yup
    .string()
    .label(t('paymentReference'))
    .min(3)
    .max(70)
    .required()
    .matches(
      ALPHANUMERIC_VALIDATION,
      t('fieldAlphanumeric', {
        field: t('paymentReference'),
        interpolation: { escapeValue: false },
      })
    )
  // This is used on the confirmation screen
  const destinationWalletName = yup.string()
  const destinationCustomerName = yup.string()

  const formFields = {
    walletTransferType,
    customerReference,
    destinationWallet,
    amount,
    paymentReference,
    // This is used on the confirmation screen
    destinationWalletName,
    destinationCustomerName,
  }

  return yup.object(formFields)
}
